export default __webpack_public_path__ + "static/media/spin-bg-8.51d5f9e0.png";